import { Input } from 'antd';
import React from 'react';
import FormItem from 'components/FormItem';
import patterns from 'utils/patterns';

export interface PhoneProps {
    name?: string;
    size?: 'large' | 'middle' | 'small';
    disabled?: boolean;
    disabledValidate?: boolean;
    line?: boolean;
}

const Phone: React.FC<PhoneProps> = ({ name = 'phone', disabled, size, line = true, disabledValidate }) => {
    const $validators = {
        isPhone: (value, prop, { validMessage: { isPhone } }) => {
            if (disabledValidate) {
                return true;
            }

            if (patterns.isPhone(value)) {
                return true;
            }

            return isPhone;
        },
        isError: () => true
    };

    return (
        <FormItem
            name={name}
            $validators={$validators}
            isPhone
            isError
            required
            line={line}
            validMessage={{
                required: __('Please enter your phone number'),
                isPhone: __('Please enter a valid phone number')
            }}>
            <Input size={size} placeholder={__('Phone Number')} disabled={disabled} />
        </FormItem>
    );
};

export default Phone;
